export default __webpack_public_path__ + "static/media/74.09fc268e.svg";